<div class="edit-page">

  <!-- HEADER -->

  <div class="visitor">

    <button class="close" (click)="close()">
      <img class="cross-icon" src="icons/profile-close.svg" />
    </button>

    <span class="visitor-txt">
      Update All Family Code
    </span>

  </div>

  <!-- TOP -->

  <p class="form-header">

    Enter details to update all the family members



  </p>

  <!-- STEP 1 + STEP 2 -->

  @if(!showAgreement){

  <!-- FC INPUT -->

  @if(!showMapping){

  <input type="text" maxlength="12" class="text-box-active" placeholder="Enter new family code" [(ngModel)]="fc" />

  }
  <!-- MAPPING STEP -->

  @if(showMapping){

  <div class="mapping-container">

    <!-- PRIMARY MEMBER -->

    <div class="mapping-title">
      Primary Member
    </div>

    @for(
    member of data.profileList;
    track member;
    let i = $index
    ){

    @if(member.isPrimaryDevotee){

    <div class="mapping-row primary-row">

      <!-- LEFT -->

      <div class="left-member">

        <div class="member-avatar">

          {{member.devoteeFirstName?.charAt(0)}}

        </div>

        <div class="member-details">

          <div class="member-name">

            {{member.devoteeFirstName}}
            {{member.devoteeMiddleName || ''}}
            {{member.devoteeLastName}}

          </div>

          <div class="member-code">

            {{member.devoteeMemberCode}}

          </div>

        </div>

      </div>

      <!-- RIGHT -->

      <div class="right-select">

        <mat-select [(ngModel)]="
                member.selectedMappedDevotee
              " placeholder="Select member">

          <mat-option *ngFor="
                  let m of getFilteredMembers(member)
                " [value]="m">

            {{m.fullName}}

          </mat-option>

        </mat-select>

      </div>

    </div>

    }

    }

    <!-- OTHER MEMBERS -->

    <div class="mapping-title secondary-title">
      Other Family Members
    </div>

    @for(
    member of data.profileList;
    track member;
    let i = $index
    ){

    @if(!member.isPrimaryDevotee){

    <div class="mapping-row">

      <!-- LEFT -->

      <div class="left-member">

        <div class="member-avatar">

          {{member.devoteeFirstName?.charAt(0)}}

        </div>

        <div class="member-details">

          <div class="member-name">

            {{member.devoteeFirstName}}
            {{member.devoteeMiddleName || ''}}
            {{member.devoteeLastName}}

          </div>

          <div class="member-code">

            {{member.devoteeMemberCode}}

          </div>

        </div>

      </div>

      <!-- RIGHT -->

      <div class="right-select">

        <mat-select [(ngModel)]="
                member.selectedMappedDevotee
              " placeholder="Select Member">

          <mat-option *ngFor="
                  let m of getFilteredMembers(member)
                " [value]="m">

            {{m.fullName}}

          </mat-option>

        </mat-select>

      </div>

    </div>

    }

    }

  </div>

  }

  }

  <!-- AGREEMENT STEP -->

  <!-- AGREEMENT STEP -->

  @if(showAgreement){

  <div class="agreement-container">

    <div class="agreement-scroll">

      <div class="agreement-title">
        Agreement
      </div>

      <div class="agreement-text">

        By checking the below box, I agree that I have read all the terms and
        conditions, as present in the link

        <span class="highlight-text">
          Terms & Conditions
        </span>

        and have also read the general guidelines of accommodation and it's
        various processes to be followed, as described in the link

        <span class="highlight-text">
          Guidelines
        </span>

        and I hereby consent that I have understood and would abide by it in full
        and also hereby declare that I would convey the information present in the
        aforementioned link to all the visitors visiting the Satsang Ashram,
        Deoghar through the booking made using this online Accommodation System
        to abide by the same terms and conditions and guidelines without any
        deviations.

        Moreover, I further declare that I would be fully responsible for any
        inappropriate conduct or deviations from the information shared in the
        aforementioned link, and would not held Satsang Deoghar or any of it's
        associates responsible for whatsoever.

      </div>

      <div class="agreement-form">

        <span class="agreement-label">
          I,
        </span>

        <input type="text" class="agreement-input" [(ngModel)]="agreementName" />

        <label class="radio-item">

          <input type="radio" name="relation" value="Son Of" [(ngModel)]="selectedRelation" />

          Son Of

        </label>

        <label class="radio-item">

          <input type="radio" name="relation" value="Daughter Of" [(ngModel)]="selectedRelation" />

          Daughter Of

        </label>

        <label class="radio-item">

          <input type="radio" name="relation" value="Wife Of" [(ngModel)]="selectedRelation" />

          Wife Of

        </label>

        <input type="text" class="agreement-input small" placeholder="Enter relation name" [(ngModel)]="relationName" />

        <span class="agreement-label">
          from place
        </span>

        <input type="text" class="agreement-input" placeholder="Enter place" [(ngModel)]="place" />

      </div>

    </div>

  </div>

  }
  <!-- ACTIONS -->

  @if(!showAgreement){

  <div class="action-row">

    <button class="ac-secondary-btn" (click)="close()">
      Cancel
    </button>

    <button class="primary-btn" (click)="continue()">
      Continue
    </button>

  </div>

  }

  <!-- AGREEMENT ACTIONS -->

  @if(showAgreement){

  <div class="action-row">

    <button class="ac-secondary-btn" (click)="showAgreement = false">
      Back
    </button>

    <button class="primary-btn" (click)="continue()">
      Save
    </button>

  </div>

  }

</div>